<main class="page-container">
    <section class="marketing">
        <iframe class="iframe-embed" title="marketing" frameBorder="0" src="https://landing-embed.zint.io/"></iframe>
    </section>

    <section class="container left-side">
        <div class="row mx-0 justify-content-xl-center">
            <div class="col col-xl-8 card register-login-padding">
                
                <!-- Step 1: Email entry -->
                <div *ngIf="!showConfirmation">
                    <h1>Log in with SSO</h1>
                    <p class="sso-description">Enter your work email address and we'll redirect you to your company's login page.</p>
                    
                    <form (ngSubmit)="onEmailSubmit()" novalidate>
                        <div class="mb-3 small-margin-top">
                            <label class="form-label" for="sso-email">Work Email</label>
                            <input 
                                type="email" 
                                class="form-control" 
                                id="sso-email" 
                                placeholder="you@company.com" 
                                [(ngModel)]="email" 
                                name="email" 
                                required
                                [disabled]="isLoading">
                        </div>
                        
                        <button 
                            type="submit" 
                            class="basic-button-base button-dark full-width"
                            [disabled]="isLoading">
                            <span *ngIf="!isLoading">Continue</span>
                            <span *ngIf="isLoading"><i class="fal fa-spinner fa-spin"></i> Looking up your company...</span>
                        </button>
                    </form>

                    <div *ngIf="ssoNotFound" class="sso-not-found small-margin-top">
                        <p class="text-warning">
                            <i class="fal fa-exclamation-triangle"></i>
                            SSO is not configured for this email domain.
                        </p>
                        <p>If you believe this is an error, please contact your IT administrator or <a href="mailto:customersuccess@zint.io">our support team</a>.</p>
                    </div>

                    <hr class="small-margin-top">
                    <a routerLink="/login" class="zint-href login-register-hyperlink">
                        <i class="fal fa-arrow-left"></i> Back to regular login
                    </a>
                </div>

                <!-- Step 2: Confirmation and SSO redirect -->
                <div *ngIf="showConfirmation">
                    <h1>Continue to {{ providerName }}</h1>
                    <p class="sso-description">You'll be redirected to your company's identity provider to complete sign in.</p>
                    
                    <div class="sso-provider-info small-margin-top">
                        <p><strong>Email:</strong> {{ email }}</p>
                        <p><strong>Provider:</strong> {{ providerName }}</p>
                    </div>

                    <form ngNoForm [attr.action]="ssoLoginUrl" method="POST">
                        <input type="hidden" name="csrfmiddlewaretoken" [value]="csrfToken">
                        <button 
                            type="submit" 
                            class="basic-button-base button-dark full-width small-margin-top">
                            <i class="fal fa-sign-in-alt"></i> Continue to {{ providerName }}
                        </button>
                    </form>

                    <hr class="small-margin-top">
                    <span class="zint-href login-register-hyperlink" (click)="goBack()">
                        <i class="fal fa-arrow-left"></i> Use a different email
                    </span>
                </div>

            </div>
        </div>
    </section>
</main>
